import Button from "@/components/ui/button";
import { useAuth } from "../../../hooks/useAuth";

type Props = {
  displayText: string;
  disabled: boolean;
  className?: string;
};

const LoginButton: React.FC<Props> = ({ displayText, disabled, className }) => {
  const { loginWithPopup } = useAuth();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    loginWithPopup({}, {});
  };

  return (
    <Button variant="black" size="lg" type="button" onClick={handleClick} className={className}>
      {displayText}
    </Button>
  );
};

export default LoginButton;
